import React from "react";
import { withStyles } from "@material-ui/core/styles";
import RadioButton from "@material-ui/icons/RadioButtonUncheckedSharp";

const styles = (theme) => ({
  radioStyle: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginTop: 4,
  },
  radioIcon: {
    color: theme.iconColor,
    fontSize: 16,
    margin: "0 8 0 0",
  },
});

const ChoiceRender = ({ classes, choiceData }) => (
  <>
    {choiceData.map(option => (
      <div className={classes.radioStyle}>
        <RadioButton className={classes.radioIcon} />
        <span>{option}</span>
      </div>
    ))}
  </>
);

export default withStyles(styles)(ChoiceRender);
